import React from 'react'
import FinanceLayout from '../../../../../../layout/components/FinanceLayout'
import InventoryForm from '../components/InventoryForm'
import InventoryStockList from '../components/InventoryStockList'
import { useAppData } from '../../../../../../context/AppDataContext'


function InventoryStockListPage() {
  const {getInventoryStockList, getInventoryTransactionList} = useAppData();
  const callBack = () =>{
		getInventoryStockList();
		getInventoryTransactionList();
	}
  return (
    <FinanceLayout>
      <div className='row'>
        <div className='col-md-12 mt-2'>
          <InventoryStockList />
        </div>
      </div>
    </FinanceLayout>
  )
}

export default InventoryStockListPage